module.exports = __webpack_public_path__ + "b0f95fd54ab52720d465f918fc6c1bfd.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_small_x1/public/games/coh_image_1.jpg
// module id = 293
// module chunks = 0